import { IndividualResponse } from '../api/customSurveys';
import { getSentimentFromAverage } from './responseFormatters';

export const calculateAverageScore = (response: IndividualResponse) => {
  const numericAnswers = response.answers.filter(
    a => a.numericValue !== null && a.numericValue !== undefined
  );

  if (numericAnswers.length === 0) return null;

  const average = numericAnswers.reduce((sum, a) => sum + (a.numericValue || 0), 0) / numericAnswers.length;
  return getSentimentFromAverage(average);
};
